import {
	Alert,
	Box,
	Breadcrumbs,
	Button,
	FormControl,
	FormControlLabel,
	Grid,
	InputLabel,
	LinearProgress,
	MenuItem,
	Paper,
	Radio,
	RadioGroup,
	Select,
	Stack,
	TextField,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material'
import {
	BtnBox,
	PageBg2,
	PageWrap,
	SearchRowItem,
	TitleText,
} from 'components/FrameworkStyle'
import { getSettings } from 'helpers/storage'
import { selectuserInfo } from 'hooks/userInfo'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import ClientSearchPopup from 'views/test/clientSearchPopup'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/ko'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import moment from 'moment'
import 'moment/locale/ko'
import { alertModal, compareDate, isValidDateType } from 'util/util'
import DownloadIcon from '@mui/icons-material/Download'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import ContentPasteSearchTwoToneIcon from '@mui/icons-material/ContentPasteSearchTwoTone'
import { PageBg } from 'components/ComponentStyles'
import {
	DataGridPremium,
	GridColDef,
	GridDensity,
	GridSelectionModel,
	GridToolbar,
	koKR,
	useGridApiRef,
} from '@mui/x-data-grid-premium'
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Line } from 'react-chartjs-2'
import dayjs from 'dayjs'
import { apiBloodReportDownload, apiBloodStat } from 'api/api'

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	ChartDataLabels,
)

// 검색조건
type SearchType = {
	clientID: number
	searchType: string
	startDate: string
	endDate: string
	patientName: string
	chartNo: string
	ward: string
	isAdmin: number
}

// 차트 타입
type ChartType = {
	monthValue: string
	avgBloodVolume: number
}

// 그리드 타입
type RowType = {
	rowNum: number
	ReceptionDate: string
	ReceptionRegNum: string
	PatientName: string
	ChartNo: string
	SocialNumber: string
	BirthDay: string
	Ward: string
	Gender: string
	PatientAge: string
	SpecimenName: string
	BloodVolume: number
	success?: number
	message?: string
}

// json 응답 타입
type BloodStatResType = {
	list: RowType[]
	avg: ChartType[]
}

const columns: GridColDef[] = [
	{
		field: 'rowNum',
		headerName: '순번',
		width: 100,
		headerAlign: 'center',
		align: 'center',
		type: 'number',
	},
	{
		field: 'ReceptionDate',
		headerName: '접수일',
		width: 110,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'ReceptionRegNum',
		headerName: '접수번호',
		width: 120,
		headerAlign: 'center',
		align: 'center',
		type: 'number',
	},
	{
		field: 'PatientName',
		headerName: '성명',
		width: 120,
		headerAlign: 'center',
	},
	{
		field: 'ChartNo',
		headerName: '차트번호',
		width: 120,
		headerAlign: 'center',
	},
	{
		field: 'Gender',
		headerName: '성별',
		width: 80,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'PatientAge',
		headerName: '나이',
		width: 80,
		headerAlign: 'center',
		align: 'center',
		type: 'number',
	},
	{
		field: 'BirthDay',
		headerName: '생년월일',
		width: 120,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'Ward',
		headerName: '병동',
		width: 120,
		headerAlign: 'center',
	},
	{
		field: 'SpecimenName',
		headerName: '검체명',
		width: 120,
		headerAlign: 'center',
	},
	{
		field: 'BloodVolume',
		headerName: '채혈량',
		width: 120,
		headerAlign: 'center',
		type: 'number',
	},
	{
		field: 'ClientReceptionNum',
		headerName: '병원 바코드',
		width: 200,
		headerAlign: 'center',
	},
]

const locales = ['ko'] as const

const Blood = () => {
	const theme = useTheme()
	const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
	const isLgUp = useMediaQuery(theme.breakpoints.up('lg'))
	const userInfo = useSelector(selectuserInfo)
	const [locale, setLocale] = useState<(typeof locales)[number]>('ko')

	const env = getSettings()
	const [disabledSave, setDisabledSave] = useState(true)
	const [disabledDel, setDisabledDel] = useState(true)
	const [disabledSearch, setDisabledSearch] = useState(false)
	const [disabledReset, setDisabledReset] = useState(false)

	const [dateRange, setDateRange] = useState('1m')

	const [search, setSearch] = useState<SearchType>({
		clientID: userInfo.infoType === 'C' ? userInfo.clientID : 0,
		searchType: 'R',
		startDate: moment(new Date()).isBefore('2023-08')
			? '2023-08'
			: moment().subtract(1, 'months').format('YYYY-MM'),
		endDate: moment().format('YYYY-MM'),
		patientName: '',
		chartNo: '',
		ward: '',
		isAdmin: userInfo.infoType === 'C' ? 0 : 1,
	})

	const onKeyUp = (e: any) => {
		if (e.keyCode === 13) actionSearch()
	}

	const actionSearch = () => {
		console.log(search)
		const startMonth = moment(search.startDate, ['YYYY-MM', 'YYYY-MM-DD'], true)
		const endMonth = moment(search.endDate, ['YYYY-MM', 'YYYY-MM-DD'], true)

		if (!startMonth.isValid() || !endMonth.isValid()) {
			alertModal('날짜 형식이 올바르지 않습니다.', 'error', () => {})
			return
		}

		if (endMonth.isBefore(startMonth, 'month')) {
			alertModal('종료일이 시작일보다 작습니다.', 'error', () => {})
			return
		}

		const monthDiff = endMonth
			.startOf('month')
			.diff(startMonth.startOf('month'), 'months')
		if (monthDiff > 12) {
			alertModal('검색기간은 1년을 초과할 수 없습니다.', 'error', () => {})
			return
		}

		if (search.clientID === 0) {
			alertModal('거래처를 선택해 주세요.', 'warning', () => {})
			return
		}
		setGridMstLoading(true)
		apiBloodStat(search)
			.then((res: BloodStatResType) => {
				console.log(res)
				if (res.list[0]?.success === 0 && res.list[0]?.message) {
					alertModal(
						res.list[0]?.message || '조회 중 오류가 발생했습니다.',
						'error',
						() => {},
					)
					setRows([])
					setChartData([])
					return
				} else {
					setRows(res.list)
					setChartData(res.avg)
				}
			})
			.finally(() => {
				setGridMstLoading(false)
			})
	}
	const actionReset = () => {
		setSearch({
			clientID: userInfo.infoType === 'C' ? userInfo.clientID : 0,
			searchType: 'R',
			startDate: moment(new Date()).isBefore('2023-08')
				? '2023-08'
				: moment().subtract(1, 'months').format('YYYY-MM'),
			endDate: moment().format('YYYY-MM'),
			patientName: '',
			chartNo: '',
			ward: '',
			isAdmin: userInfo.infoType === 'C' ? 0 : 1,
		})
	}
	const actionExcelDownload = () => {
		setSelectionModel([])
		setTimeout(() => {
			mstRef.current?.exportDataAsExcel({
				fields: columns
					.filter((col) => col.field !== 'rowNum')
					.map((col) => col.field),
			})
		}, 500)
	}

	// calulate today before n months
	const getBeforeMonth = (n: number) => {
		setSearch({
			...search,
			startDate: moment().subtract(n, 'months').format('YYYY-MM'),
		})
	}

	// calulate today before 1 year
	const getBeforeYear = (n: number) => {
		setSearch({
			...search,
			startDate: moment().subtract(n, 'years').format('YYYY-MM'),
		})
	}

	const searchDateRanageOnChange = (event: any) => {
		switch (event.target.value) {
			case '1m':
				getBeforeMonth(1)
				break
			case '3m':
				getBeforeMonth(3)
				break
			case '6m':
				getBeforeMonth(6)
				break
			case '1y':
				getBeforeYear(1)
				break
			default:
				break
		}
		setDateRange(event.target.value)
		setDisabledSearch(false)
	}

	// 내부사용자일 경우 거래처 선택 팝업
	const [clientDialogOpen, setClientDialogOpen] = useState(false)
	const [searchClientName, setSearchClientName] = useState('')
	const clientDialogClose = () => {
		setClientDialogOpen(false)
	}
	const clientPopupOpenAction = () => {
		setClientDialogOpen(true)
	}
	const clientPopupSubmit = (e: any) => {
		setSearchClientName(e.ClientName)
		setSearch({
			...search,
			clientID: e.ClientID,
		})
		setClientDialogOpen(false)
	}

	// date picker on change event
	const dateRanageOnChange = (e: any, target: string) => {
		if (moment(new Date(e)).isBefore('2023-08')) {
			alertModal('2023-08 이전 날짜는 조회할 수 없습니다.', 'error', () => {})
			setSearch({
				...search,
				startDate: '2023-08',
			})
			return
		} else {
			if (moment(new Date(e)).format('yyyy-MM').length === 7) {
				if (!isValidDateType(e)) {
					alertModal('날짜 형식이 올바르지 않습니다.', 'error', () => {})
					setDisabledSearch(true)
					return
				}

				if (target === 'startDate') {
					let diffValue = compareDate(e, search.endDate)
					if (diffValue > 0) {
						alertModal('시작일이 종료일보다 큽니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
					if (
						moment(search.endDate, ['YYYY-MM', 'YYYY-MM-DD'], true)
							.startOf('month')
							.diff(moment(e).startOf('month'), 'months') > 12
					) {
						alertModal('검색기간은 1년을 초과할 수 없습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
				} else if (target === 'endDate') {
					let diffValue = compareDate(e, search.startDate)
					if (diffValue < 0) {
						alertModal('종료일이 시작일보다 작습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
					if (
						moment(e)
							.startOf('month')
							.diff(
								moment(search.startDate, ['YYYY-MM', 'YYYY-MM-DD'], true).startOf(
									'month',
								),
								'months',
							) > 12
					) {
						alertModal('검색기간은 1년을 초과할 수 없습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
				}

				setDisabledSearch(false)

				setSearch((prevState) => {
					return {
						...prevState,
						[target]: moment(new Date(e)).format('yyyy-MM'),
					}
				})
			} else {
				setDisabledSearch(true)
			}
		}
	}

	const [chartData, setChartData] = useState<ChartType[]>([])

	// grid
	const mstRef = useGridApiRef()
	const [rows, setRows] = useState<RowType[]>([])
	const [gridMstLoading, setGridMstLoading] = useState(false)
	const [gridMstPageSize, setGridMstPageSize] = useState(env.row ? env.row : 100)
	const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([])

	const options = {
		maintainAspectRatio: true,
		responsive: true,
		aspectRatio: 2,
		layout: {
			padding: {
				top: 30,
			},
		},
		plugins: {
			legend: {
				position: 'top' as const,
				display: false,
			},
			title: {
				display: false,
				text: '이전 결과',
			},
			datalabels: {
				display: true,
				color: '#333',
				anchor: 'end' as const,
				align: 'end' as const,
				formatter: (value: number) => value.toFixed(1) + ' ml',
				font: {
					weight: 'bold' as const,
					size: 13,
				},
			},
		},
		scales: {
			x: {
				offset: true,
				ticks: {
					font: {
						size: 13,
					},
				},
			},
			y: {
				beginAtZero: true,
				grace: '10%',
				ticks: {
					stepSize: 1,
					font: {
						size: 13,
					},
					callback: function (value: any) {
						return value + ' ml'
					},
				},
			},
		},
	}

	const labels = chartData.map((item) => item.monthValue)

	const data = {
		labels,
		datasets: [
			{
				label: '평균 채혈량',
				data: chartData.map((item) => item.avgBloodVolume),
				borderColor: 'rgb(255, 99, 132)',
				backgroundColor: 'rgba(255, 99, 132, 0.5)',
				pointRadius: 10,
				pointHoverRadius: 10,
				pointHitRadius: 10,
			},
		],
	}

	// 리포트 다운로드
	const actionReportDownload = () => {
		const request = {
			clientID:
				userInfo.infoType === 'S' || userInfo.infoType === 'W'
					? search.clientID
					: userInfo.clientID,
			searchType: search.searchType,
			startDate: search.startDate,
			endDate: search.endDate,
			patientName: search.patientName,
			chartNo: search.chartNo,
			ward: search.ward,
			zoom: 100,
		}
		console.log(request)
		apiBloodReportDownload(request).then((res) => {
			const url = window.URL.createObjectURL(res.data)
			const a = document.createElement('a')
			a.href = url

			// 서버에서 보내준 파일명 추출
			const contentDisposition =
				res.headers['Content-Disposition'] || res.headers['content-disposition']
			let filename = `${userInfo.clientName}_평균채혈량리포트_${moment().format('YYYY-MM-DD')}.pdf`
			if (contentDisposition) {
				const filenameMatch = contentDisposition.match(
					/filename\*?=(?:UTF-8'')?["']?([^;"'\n]+)["']?/i,
				)
				if (filenameMatch && filenameMatch[1]) {
					filename = decodeURIComponent(filenameMatch[1])
				}
			}

			a.download = filename
			a.click()
			window.URL.revokeObjectURL(url)
		})
	}

	useEffect(() => {
		if (userInfo?.infoType === 'C') actionSearch()
	}, [])

	const bloodVolumeValues = rows
		.map((row) => {
			const numericValue = Number(String(row.BloodVolume).replace(/[^0-9.-]/g, ''))
			return Number.isFinite(numericValue) ? numericValue : null
		})
		.filter((value): value is number => value !== null)

	const averageBloodVolume =
		bloodVolumeValues.length > 0
			? bloodVolumeValues.reduce((sum, value) => sum + value, 0) /
				bloodVolumeValues.length
			: 0

	return (
		<>
			<ClientSearchPopup
				dialogOpen={clientDialogOpen}
				dialogClose={clientDialogClose}
				popupSubmit={clientPopupSubmit}
			/>
			<Stack
				sx={{
					position: 'sticky',
					top: '50px',
					zIndex: 100,
					padding: '0.5rem',
					borderRadius: '0.5rem',
					backgroundColor:
						theme.palette.mode === 'dark' ? 'rgba(50, 48, 54, 1)' : '#fff',
					'@media (max-width: 600px)': {
						position: 'relative',
						paddingTop: '15px',
						top: '0px',
					},
				}}
			>
				<PageWrap style={{ marginBottom: '0.5rem' }}>
					<PageBg2 sx={{ padding: '0.3rem 0.3rem 0rem 0.5rem' }}>
						<Breadcrumbs
							separator={<NavigateNextIcon fontSize="small" />}
							aria-label="breadcrumb"
							sx={{
								'@media (max-width: 900px': {
									display: 'none',
								},
							}}
						>
							<TitleText
								key="3"
								color="text.primary"
								sx={{ fontWeight: '500', fontSize: 17 }}
							>
								채혈량 통계
							</TitleText>
						</Breadcrumbs>
						<BtnBox>
							<div>
								<span>
									<Button
										size="small"
										color="success"
										variant="contained"
										startIcon={isMdUp && <RotateLeftIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={disabledReset}
										onClick={actionReset}
									>
										초기화
									</Button>
								</span>
								<span>
									<Button
										size="small"
										color="primary"
										variant="contained"
										startIcon={isMdUp && <ContentPasteSearchTwoToneIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={disabledSearch}
										onClick={actionSearch}
									>
										조회
									</Button>
								</span>
								<span>
									<Button
										variant="contained"
										color="secondary"
										size="small"
										startIcon={<DownloadIcon />}
										onClick={actionExcelDownload}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
									>
										엑셀 다운로드
									</Button>
								</span>
								<span>
									<Button
										variant="contained"
										color="secondary"
										size="small"
										startIcon={<DownloadIcon />}
										onClick={actionReportDownload}
									>
										리포트 다운로드
									</Button>
								</span>
							</div>
						</BtnBox>
					</PageBg2>
				</PageWrap>
				<Box
					component="form"
					noValidate
					autoComplete="off"
					onKeyUp={onKeyUp}
					sx={{
						borderTop:
							theme.palette.mode === 'dark'
								? '1px solid rgba(81, 81, 81, 1)'
								: '1px solid #ccc',
						paddingTop: '1rem',
					}}
				>
					<LocalizationProvider
						dateAdapter={AdapterDayjs}
						adapterLocale={locale}
						dateFormats={{
							monthAndYear: 'YYYY년 M월',
						}}
					>
						<SearchRowItem>
							<p className="labelText">조회조건</p>
							<Grid
								container
								spacing={1}
							>
								<Grid
									item
									xs={6}
									sm={3}
									md={3}
								>
									<FormControl fullWidth>
										<InputLabel id="searchType-select-label">기간 유형</InputLabel>
										<Select
											labelId="searchType-select-label"
											id="searchTypee-simple-select"
											value={search.searchType}
											label="기간 유형"
											onChange={(e) => {
												setSearch({
													...search,
													searchType: e.target.value,
												})
											}}
											size={'small'}
										>
											<MenuItem value={'R'}>접수일자</MenuItem>
											<MenuItem value={'D'}>보고일자</MenuItem>
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={3}
								>
									<DatePicker
										views={['month', 'year']}
										label="시작월"
										minDate={dayjs('2018-03-01')}
										maxDate={dayjs(new Date())}
										inputFormat="YYYY-MM"
										value={search.startDate}
										onChange={(newValue) => {
											dateRanageOnChange(newValue, 'startDate')
										}}
										renderInput={(params) => (
											<TextField
												{...params}
												inputProps={{
													...params.inputProps,
													readOnly: true,
												}}
												helperText={null}
												size="small"
												fullWidth
											/>
										)}
									/>
								</Grid>

								<Grid
									item
									xs={6}
									sm={3}
									md={3}
								>
									<DatePicker
										views={['month', 'year']}
										label="종료월"
										minDate={dayjs('2018-03-01')}
										maxDate={dayjs(new Date())}
										inputFormat="YYYY-MM"
										value={search.endDate}
										onChange={(newValue) => {
											dateRanageOnChange(newValue, 'endDate')
										}}
										renderInput={(params) => (
											<TextField
												{...params}
												inputProps={{
													...params.inputProps,
													readOnly: true,
												}}
												helperText={null}
												size="small"
												fullWidth
											/>
										)}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={3}
								>
									<FormControl fullWidth>
										<InputLabel id="date-range-select-label">조회 기간</InputLabel>
										<Select
											labelId="date-range-select-label"
											id="date-range-simple-select"
											value={dateRange}
											label="조회 기간"
											onChange={searchDateRanageOnChange}
											size={'small'}
										>
											<MenuItem value={'0'}>선택하세요.</MenuItem>
											<MenuItem value={'1m'}>1개월</MenuItem>
											<MenuItem value={'3m'}>3개월</MenuItem>
											<MenuItem value={'6m'}>6개월</MenuItem>
											<MenuItem value={'1y'}>1년</MenuItem>
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={3}
								>
									<TextField
										label="수진자명"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										value={search.patientName}
										onChange={(e) =>
											setSearch({
												...search,
												patientName: e.target.value,
											})
										}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={3}
								>
									<TextField
										label="차트번호"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										value={search.chartNo}
										onChange={(e) =>
											setSearch({
												...search,
												chartNo: e.target.value,
											})
										}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={3}
								>
									<TextField
										label="병동"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										value={search.ward}
										onChange={(e) =>
											setSearch({
												...search,
												ward: e.target.value,
											})
										}
									/>
								</Grid>
								{(userInfo.infoType === 'S' || userInfo.infoType === 'W') && (
									<Grid
										item
										xs={6}
										sm={3}
										md={3}
									>
										<TextField
											label="거래처"
											variant="outlined"
											size="small"
											type="text"
											fullWidth
											aria-readonly={true}
											value={searchClientName}
											onClick={clientPopupOpenAction}
										/>
									</Grid>
								)}
							</Grid>
						</SearchRowItem>
					</LocalizationProvider>
				</Box>
			</Stack>
			<Paper
				elevation={0}
				sx={{ width: '100%', overflow: 'hidden', mt: 2 }}
			>
				<Grid container>
					<Grid
						item
						xs={12}
					>
						<PageBg>
							<Box
								sx={{
									height: 'calc(100vh - 300px)',
									'@media (max-width: 1199px)': {
										height: '400px',
										overflow: 'auto',
									},
								}}
							>
								<Box
									sx={{
										height: '50%',
										display: 'flex',
										justifyContent: 'center',
									}}
								>
									<div
										style={{
											backgroundColor: '#fff',
											padding: '1rem',
											width: '65%',
											maxWidth: '1200px',
											margin: '0 auto',
											height: '100%',
										}}
									>
										<Line
											options={options}
											data={data}
										/>
									</div>
								</Box>
								<Box sx={{ height: 'calc(50% - 5rem)', mt: 2 }}>
									<Alert
										severity="info"
										sx={{ mb: 2 }}
									>
										평균 채혈량 : {averageBloodVolume.toFixed(1)} ml
									</Alert>
									<DataGridPremium
										rows={rows}
										apiRef={mstRef}
										columns={columns}
										getRowId={(row) => row.rowNum}
										pageSize={gridMstPageSize}
										onPageSizeChange={(newPageSize) => setGridMstPageSize(newPageSize)}
										rowsPerPageOptions={[5, 10, 20, 50, 100]}
										pagination
										autoHeight={false}
										loading={gridMstLoading}
										components={{
											Toolbar: GridToolbar,
											LoadingOverlay: LinearProgress,
										}}
										selectionModel={selectionModel}
										onSelectionModelChange={(newSelection) => {
											setSelectionModel(newSelection)
										}}
										localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
										componentsProps={{
											toolbar: {
												csvOptions: { disableToolbarButton: true },
												excelOptions: { disableToolbarButton: true },
												printOptions: { disableToolbarButton: true },
												showQuickFilter: false,
												quickFilterProps: { debounceMs: 250 },
											},
										}}
										density={(env.desnse as GridDensity) || 'compact'}
										initialState={{
											columns: {
												columnVisibilityModel: {
													ReceptionID: false,
													id: false,
												},
											},
										}}
										sx={{
											'& .MuiDataGrid-columnHeaderTitleContainer': {
												fontSize: '13px',
											},
											'& .MuiDataGrid-cell': {
												fontSize: '13px !important',
												borderRight:
													theme.palette.mode === 'dark'
														? '1px solid rgba(81, 81, 81, 1)'
														: '1px solid rgba(224, 224, 224, 1)',
											},
										}}
									/>
								</Box>
							</Box>
						</PageBg>
					</Grid>
				</Grid>
			</Paper>
		</>
	)
}
export default Blood
